import FormConditionService from '../Service/FormConditionService'
import FormValidationService from '../Service/FormValidationService'

const formConditionService = new FormConditionService()
formConditionService.init()

const formValidationService = new FormValidationService()
formValidationService.init()
